import React from 'react';

export type VideoType = {
  videoSrc: {
    webm?: string;
    mp4: string;
  };
  fallbackImageSrc: string;
  height?: string;
  width?: string;
  autoPlay?: boolean;
  loop?: boolean;
  muted?: boolean;
  playsInline?: boolean;
  preload?: 'none' | 'metadata' | 'auto';
  controls?: boolean;
  className?: string;
};

export const Video: React.FC<VideoType> = ({
  videoSrc,
  fallbackImageSrc,
  className,
  ...args
}) => (
  <div className={className}>
    <video poster={fallbackImageSrc} {...args}>
      {videoSrc.webm && <source src={videoSrc.webm} type="video/webm" />}
      <source src={videoSrc.mp4} type="video/mp4" />
    </video>
  </div>
);
